module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001333.2fc4c413.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001333.pdf
// module id = 342
// module chunks = 0